import React, { useState } from "react";
import { Tabs, Tab, Box } from "@mui/material";
import { foundationalSetupSections } from "../../../constants";
import Regions from "../foundation/Regions";
import Locations from "../foundation/Locations";
import Companies from "../foundation/Companies";
import CostCenters from "../foundation/CostCenters";
import Departments from "../foundation/Departments";
import GradeProfiles from "../foundation/GradeProfiles";
import JobProfiles from "../foundation/JobProfiles";

const FoundationalSetup = ({ questionnaireData, setQuestionnaireData }) => {
  const [activeTab, setActiveTab] = useState("regions");

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <div className="space-y-6">
      <h3 className="text-xl font-medium text-gray-900">Foundational Setup</h3>
      <p className="text-gray-600">
        Define your organizational structure and foundational elements for
        Workday.
      </p>

      <div className="bg-yellow-50 p-4 rounded-lg mb-6">
        <p className="text-sm text-yellow-800">
          <strong>Note:</strong> All foundational items include Legacy Name,
          Legacy Code, Description, New Name, New Description, and Comments. You
          can mark each record as "Not Required", "Merged", or "Keep".
        </p>
      </div>
      <div>
        <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
          <Tabs
            value={activeTab}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="foundational setup sections"
            sx={{
              "& .MuiTab-root": {
                textTransform: "none",
                fontSize: "0.875rem",
                minHeight: "40px",
                py: 1,
              },
            }}
          >
            {foundationalSetupSections.map((s) => (
              <Tab
                key={s.id}
                value={s.id}
                label={s.title}
                id={`foundation-tab-${s.id}`}
                aria-controls={`foundation-tabpanel-${s.id}`}
              />
            ))}
          </Tabs>
        </Box>
        <div role="tabpanel" aria-labelledby={`foundation-tab-${activeTab}`}>
          {activeTab === "regions" && (
            <Regions
              questionnaireData={questionnaireData}
              setQuestionnaireData={setQuestionnaireData}
            />
          )}
          {activeTab === "locations" && (
            <Locations
              questionnaireData={questionnaireData}
              setQuestionnaireData={setQuestionnaireData}
            />
          )}
          {activeTab === "companies" && (
            <Companies
              questionnaireData={questionnaireData}
              setQuestionnaireData={setQuestionnaireData}
            />
          )}
          {activeTab === "costCenters" && (
            <CostCenters
              questionnaireData={questionnaireData}
              setQuestionnaireData={setQuestionnaireData}
            />
          )}
          {activeTab === "departments" && (
            <Departments
              questionnaireData={questionnaireData}
              setQuestionnaireData={setQuestionnaireData}
            />
          )}
          {activeTab === "gradeProfiles" && (
            <GradeProfiles
              questionnaireData={questionnaireData}
              setQuestionnaireData={setQuestionnaireData}
            />
          )}
          {activeTab === "jobProfiles" && (
            <JobProfiles
              questionnaireData={questionnaireData}
              setQuestionnaireData={setQuestionnaireData}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default FoundationalSetup;
